import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59043758"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab-header" }, "CHEETA LOGO", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab-subheader" }, "CHEETA LOGO LOCATION:", -1))
const _hoisted_4 = { class: "cheeta-logo-position" }
const _hoisted_5 = { class: "ml-2" }
const _hoisted_6 = { class: "tab-subheader" }
const _hoisted_7 = { class: "color-thumbnail" }
const _hoisted_8 = { class: "cheeta-logo-position" }
const _hoisted_9 = { class: "color-options" }
const _hoisted_10 = ["onClick", "title"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab-header" }, "CUSTOM LOGOS", -1))
const _hoisted_12 = { class: "upload-section" }
const _hoisted_13 = ["id", "onChange"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["for"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " to upload", -1))
const _hoisted_17 = {
  key: 1,
  class: "button-container"
}
const _hoisted_18 = {
  key: 2,
  class: "loaded-image"
}
const _hoisted_19 = ["src"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Max size: 10MB"),
  /*#__PURE__*/_createElementVNode("div", null, "Accepted types: JPG,JPEG,PNG,SVG")
], -1))
const _hoisted_21 = {
  key: 0,
  class: "slider"
}
const _hoisted_22 = {
  key: 1,
  class: "axis-adjustment"
}
const _hoisted_23 = { class: "position-sliders-wrapper" }
const _hoisted_24 = {
  key: 0,
  class: "slider"
}
const _hoisted_25 = {
  key: 1,
  class: "slider"
}
const _hoisted_26 = {
  key: 2,
  class: "selectbutton-wrapper"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Slider = _resolveComponent("Slider")!
  const _component_SelectButton = _resolveComponent("SelectButton")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_DisclaimerText = _resolveComponent("DisclaimerText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cheetaLogoPositions, (element) => {
        return (_openBlock(), _createElementBlock("div", {
          key: element.id,
          class: "logo-position-radio"
        }, [
          _createVNode(_component_RadioButton, {
            modelValue: _ctx.cheetaLogoData.position,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.cheetaLogoData.position) = $event)),
            onChange: _ctx.onCheetaLogoChange,
            value: element.id
          }, null, 8, ["modelValue", "onChange", "value"]),
          _createElementVNode("label", _hoisted_5, _toDisplayString(element.label), 1)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createTextVNode(" CHEETA LOGO COLOUR: "),
      _createElementVNode("div", _hoisted_7, [
        _createTextVNode(_toDisplayString(_ctx.cheetaLogoData.color.name) + " ", 1),
        _createElementVNode("div", {
          class: "color-square",
          style: _normalizeStyle({
            'background-color': _ctx.cheetaLogoData.color.value,
          })
        }, null, 4)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colorOptions, (color, index) => {
            return (_openBlock(), _createElementBlock("div", {
              onClick: ($event: any) => (_ctx.changeCheetaLogoColor(color)),
              key: index,
              class: "color-square",
              style: _normalizeStyle({ 'background-color': color.value }),
              title: color.name
            }, null, 12, _hoisted_10))
          }), 128))
        ])
      ])
    ]),
    _hoisted_11,
    _createVNode(_component_Accordion, { activeIndex: 0 }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logosForDisplaying, (element) => {
          return (_openBlock(), _createBlock(_component_AccordionTab, {
            key: element.position,
            header: element.label
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                  id: `upload-${element.position}`,
                  type: "file",
                  onChange: ($event: any) => (_ctx.onLogoUpload($event, element?.position)),
                  accept: "image/*"
                }, null, 40, _hoisted_13), [
                  [_vShow, false]
                ]),
                (element.path === '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("label", {
                        for: `upload-${element.position}`,
                        class: "input-link"
                      }, "Browse files", 8, _hoisted_15),
                      _hoisted_16
                    ]))
                  : _createCommentVNode("", true),
                (element.path !== '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createVNode(_component_Button, {
                        icon: "pi pi-times",
                        size: "small",
                        class: "button",
                        severity: "danger",
                        onClick: ($event: any) => (_ctx.removeLogo(element.position)),
                        text: "",
                        raised: "",
                        rounded: ""
                      }, null, 8, ["onClick"])
                    ]))
                  : _createCommentVNode("", true),
                (element.path !== '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createElementVNode("img", {
                        src: element.path,
                        alt: ""
                      }, null, 8, _hoisted_19)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_20,
              (
            element.path !== '' && _ctx.activeProduct.alias !== 'basketball_shorts_8'
          )
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createVNode(_component_Slider, {
                      modelValue: element.size,
                      "onUpdate:modelValue": ($event: any) => ((element.size) = $event),
                      onChange: ($event: any) => (_ctx.logoSizeChange($event, element.position)),
                      max: 100,
                      min: 5
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                  ]))
                : _createCommentVNode("", true),
              (
            element.path !== '' &&
            _ctx.activeProductType !== 'beanie' &&
            _ctx.activeProductType !== 'crewsock' &&
            _ctx.activeProductType !== 'scarf' &&
            _ctx.activeProductType !== 'truckercap'
          )
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createTextVNode(" LOGO POSITION ADJUSTMENT "),
                    _createElementVNode("div", _hoisted_23, [
                      (
                element.path !== '' &&
                _ctx.activeProductType === 'basketball_shorts' &&
                _ctx.activeProduct.alias !== 'basketball_shorts_7' &&
                _ctx.activeProduct.alias !== 'basketball_shorts_8'
              )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            _createTextVNode(" horizontal: " + _toDisplayString(element.offsetX) + " ", 1),
                            _createVNode(_component_Slider, {
                              modelValue: element.offsetX,
                              "onUpdate:modelValue": ($event: any) => ((element.offsetX) = $event),
                              onChange: ($event: any) => (
                  _ctx.logoPositionOffsetChanged($event, 'offsetX', element.position)
                ),
                              max: _ctx.horizontalSliderRange.max,
                              min: _ctx.horizontalSliderRange.min
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "max", "min"])
                          ]))
                        : _createCommentVNode("", true),
                      (
                _ctx.activeProduct.alias !== 'basketball_shorts_3' &&
                _ctx.activeProduct.alias !== 'basketball_shorts_8'
              )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createTextVNode(" vertical: " + _toDisplayString(element.offsetY) + " ", 1),
                            _createVNode(_component_Slider, {
                              modelValue: element.offsetY,
                              "onUpdate:modelValue": ($event: any) => ((element.offsetY) = $event),
                              onChange: ($event: any) => (
                  _ctx.logoPositionOffsetChanged($event, 'offsetY', element.position)
                ),
                              max: _ctx.verticalSliderRange.max,
                              min: _ctx.verticalSliderRange.min
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "max", "min"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.activeProductType === 'cuthoodie' && element.path !== '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createVNode(_component_SelectButton, {
                      modelValue: element.embroidery,
                      "onUpdate:modelValue": ($event: any) => ((element.embroidery) = $event),
                      options: _ctx.embroideryOptions,
                      onChange: ($event: any) => (_ctx.logoTypeAddonsChanged(element.position)),
                      unselectable: "",
                      optionLabel: "name",
                      optionValue: "value",
                      dataKey: "value",
                      "aria-labelledby": "custom"
                    }, {
                      option: _withCtx((slotProps) => [
                        _createTextVNode(_toDisplayString(slotProps.option.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue", "options", "onChange"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["header"]))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(_component_DisclaimerText)
  ]))
}